import { render, staticRenderFns } from "./OthersIcon.vue?vue&type=template&id=2d35119a&"
import script from "./OthersIcon.vue?vue&type=script&lang=ts&"
export * from "./OthersIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports